export default {"src":"/_next/static/media/gym.a6fcf20a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};